import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { LearnersReportDto, ReportsChart, ReportDetailsDto, ReportsTableParams, UpdateReportsFilter } from "src/app/_models/Reports";
import { LearnerReportActionTypes } from "src/app/constants/StoreConstants";

export const ResetReportState = createAction(
  LearnerReportActionTypes.ResetReportState
);

export const GetLearnerReportTypes = createAction(
  LearnerReportActionTypes.GetLearnerReportTypes,
  props<{tabIndex: number}>()
);

export const GetLearnerReportTypesSuccess = createAction(
  LearnerReportActionTypes.GetLearnerReportTypesSuccess,
  props<{result: string[]}>()
);

export const GetLearnerReportTypesError = createAction(
  LearnerReportActionTypes.GetLearnerReportTypesError,
  props<{error: HttpErrorResponse}>()
);

export const UpdateReportSessionFilter = createAction(
  LearnerReportActionTypes.UpdateReportSessionFilter,
  props<{reportType: number, filter: UpdateReportsFilter}>()
);

export const UpdateReportSessionFilterSuccess = createAction(
  LearnerReportActionTypes.UpdateReportSessionFilterSuccess,
  props<{result: boolean}>()
);

export const UpdateReportSessionFilterError = createAction(
  LearnerReportActionTypes.UpdateReportSessionFilterError,
  props<{error: HttpErrorResponse}>()
);

export const ResetReportSessionFilterState = createAction(
  LearnerReportActionTypes.ResetReportSessionFilterState
);

export const GetReportsFilter = createAction(
  LearnerReportActionTypes.GetReportsFilter,
  props<{reportType: number}>()
);

export const GetReportsFilterSuccess = createAction(
  LearnerReportActionTypes.GetReportsFilterSuccess,
  props<{reportsFilter: UpdateReportsFilter}>()
);

export const GetReportsFilterError = createAction(
  LearnerReportActionTypes.GetReportsFilterError,
  props<{error: HttpErrorResponse}>()
);

export const ResetGetReportsFilter = createAction(
  LearnerReportActionTypes.ResetGetReportsFilter
);

export const GenerateReports = createAction(
  LearnerReportActionTypes.GenerateReports,
  props<{reportType: number}>()
);

export const GenerateReportsSuccess = createAction(
  LearnerReportActionTypes.GenerateReportsSuccess,
  props<{result: boolean}>()
);

export const GenerateReportsError = createAction(
  LearnerReportActionTypes.GenerateReportsError,
  props<{error: HttpErrorResponse}>()
);

export const GetReportsTableResult = createAction(
  LearnerReportActionTypes.GetReportsTableResult,
  props<{reportType: number, pageNumber: number, isInitialLoad: boolean}>()
);

export const GetReportsTableResultSuccess = createAction(
  LearnerReportActionTypes.GetReportsTableResultSuccess,
  props<{result: LearnersReportDto[]}>()
);

export const GetReportsTableResultError = createAction(
  LearnerReportActionTypes.GetReportsTableResultError,
  props<{error: HttpErrorResponse}>()
);

export const GetReportDetails = createAction(
  LearnerReportActionTypes.GetReportDetails,
  props<{reportType: number}>()
);

export const GetReportDetailsSuccess = createAction(
  LearnerReportActionTypes.GetReportDetailsSuccess,
  props<{result: ReportDetailsDto}>()
);

export const GetReportDetailsError = createAction(
  LearnerReportActionTypes.GetReportDetailsError,
  props<{error: HttpErrorResponse}>()
);

export const UpdateTableReportByParams = createAction(
  LearnerReportActionTypes.UpdateTableReportByParams,
  props<{reportType: number, params: ReportsTableParams}>()
);

export const UpdateTableReportByParamsSuccess = createAction(
  LearnerReportActionTypes.UpdateTableReportByParamsSuccess,
  props<{result: boolean}>()
);

export const UpdateTableReportByParamsError = createAction(
  LearnerReportActionTypes.UpdateTableReportByParamsError,
  props<{error: HttpErrorResponse}>()
);

export const GetLearnerReportListLength = createAction(
  LearnerReportActionTypes.GetLearnerReportListLength,
  props<{reportType: number}>()
);

export const GetLearnerReportListLengthSuccess = createAction(
  LearnerReportActionTypes.GetLearnerReportListLengthSuccess,
  props<{result: number}>()
);

export const GetLearnerReportListLengthError = createAction(
  LearnerReportActionTypes.GetLearnerReportListLengthError,
  props<{error: HttpErrorResponse}>()
);

export const GetLearnerReportsChart = createAction(
  LearnerReportActionTypes.GetLearnerReportsChart,
  props<{reportType: number}>()
);

export const GetLearnerReportsChartSuccess = createAction(
  LearnerReportActionTypes.GetLearnerReportsChartSuccess,
  props<{result: ReportsChart[]}>()
);

export const GetLearnerReportsChartError = createAction(
  LearnerReportActionTypes.GetLearnerReportsChartError,
  props<{error: HttpErrorResponse}>()
);

export const ResetLearnerReportsChart = createAction(
  LearnerReportActionTypes.ResetLearnerReportsChart
);

export const ResetLearnerReportTable = createAction(
  LearnerReportActionTypes.ResetLearnerReportTable,
  props<{reportType: number}>()
);

export const ResetLearnerReportTableSuccess = createAction(
  LearnerReportActionTypes.ResetLearnerReportTableSuccess,
  props<{result: boolean}>()
);

export const ResetLearnerReportTableError = createAction(
  LearnerReportActionTypes.ResetLearnerReportTableError,
  props<{error: HttpErrorResponse}>()
);

export const ExportReportsTable = createAction(
  LearnerReportActionTypes.ExportReportsTable,
  props<{reportType: number}>()
);

export const ExportReportsTableSuccess = createAction(
  LearnerReportActionTypes.ExportReportsTableSuccess,
  props<{result: LearnersReportDto[]}>()
);

export const ExportReportsTableError = createAction(
  LearnerReportActionTypes.ExportReportsTableError,
  props<{error: HttpErrorResponse}>()
);